var React = require('react');

function HackerNewsLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v16h16V0zm15 15H1V1h14zM7.61 9a.57.57 0 0 1 0 .32v3.06h1.17V9.23a.41.41 0 0 1 0-.19c.77-1.46 1.56-2.92 2.33-4.38.09-.21.22-.4.29-.62a7.46 7.46 0 0 0-1.16 0c-.54 1.11-1.11 2.27-1.7 3.41-.1.18-.18.37-.29.54-.13-.21-.23-.44-.35-.66L6.34 4.11S6.3 4 6.24 4H5c.14.32.32.62.48.93C6.18 6.31 6.9 7.64 7.61 9z","fill":"currentColor"}));
}

HackerNewsLogo.defaultProps = {"viewBox":"0 0 16 16","version":"1.1"};

module.exports = HackerNewsLogo;

HackerNewsLogo.default = HackerNewsLogo;
